<div
  class="wrap"
  [class.success]="data.type === 'success'"
  [class.error]="data.type === 'error'"
  [class.info]="data.type === 'info'"
  [class.warning]="data.type === 'warning'"
>
  <div class="head">
    <div class="icon">
      <mat-icon>{{ icon() }}</mat-icon>
    </div>

    <div class="texts">
      <div class="title">{{ data.title }}</div>
      <div class="msg">{{ data.message }}</div>
    </div>
  </div>

  <div class="actions">
    <button mat-flat-button class="btn" (click)="close()">
      {{ data.buttonText || "Aceptar" }}
    </button>
  </div>
</div>
